import { t } from '@lingui/core/macro';
import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { getShouldPayForBooking } from 'noddi-util';

interface Props {
  booking: BookingRecordDetailsCustomer;
}

/** Paid / unpaid beside the status chip; outline, since the status chip is the one colored badge. */
export const BookingPaymentBadge = ({ booking }: Props) => {
  const { order, cancelledAt, completedAt, isFullyUnableToComplete, isPartiallyUnableToComplete } = booking;

  if (cancelledAt) {
    return null;
  }

  if (getShouldPayForBooking(order)) {
    // A completed booking's status chip says Unpaid itself, unless it shows an unable-to-complete outcome instead.
    const isUnpaidInStatusChip = completedAt && !isFullyUnableToComplete && !isPartiallyUnableToComplete;
    return isUnpaidInStatusChip ? null : (
      <NoddiBadge variant='outline'>
        <NoddiIcon name='Clock' />
        {order.amountPaid.amount > 0 ? t`Partially paid` : t`Unpaid`}
      </NoddiBadge>
    );
  }

  // Invoice, shop-collected and free orders have nothing to collect here.
  // A shop-collected order is fully paid, so the customer sees Paid.
  if (order.amountPaid.amount > 0 && order.amountOutstanding.amount <= 0) {
    return (
      <NoddiBadge variant='outline'>
        <NoddiIcon name='Check' className='text-emerald-500' />
        {t`Paid`}
      </NoddiBadge>
    );
  }

  return null;
};
